
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/highlighter.en.md?watch=parent';
    export const demoIndex = {
  ids: [],
  getter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/highlighter.en.md?type=demo')
};